(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalWhitePaper = {
    attach(context) {
      const $toggleGraphPaper = $('.whitepaper-toggle-graph-paper', context);
      const $clearCanvas = $('.whitepaper-reset', context);
      const $addText = $('.whitepaper-add-text', context);
      const $editText = $('.whitepaper-edit-text', context);
      const $drawingMode = $('.whitepaper-drawing-mode', context);

      if (typeof Drupal.behaviors.questionModalWhitePaper.whitePapers == "undefined") {
        Drupal.behaviors.questionModalWhitePaper.whitePapers = [];
      }

      $('.whitepaper-toggle-graph-paper, .whitepaper-reset, .whitepaper-add-text, .whitepaper-edit-text, .whitepaper-drawing-mode')
      .on('click touchstart', function (e) {
        e.preventDefault();
      });

      // Initialize whiteboards if not in the body context
      if (!$(context).is("body")) {
        setTimeout(() => {
          const $whiteboardInputs = $(".whiteboard-json-marks", context);

          // Skip reinitialization if already initialized
          if ($whiteboardInputs.data('initialized')) return;
          $whiteboardInputs.data('initialized', true);

          $whiteboardInputs.each((key, value) => {
            const $input = $(value);
            const jsonData = $input.val();
            const targetId = $input.attr("data-input-id");

            // Initialize whiteboard for the input
            Drupal.behaviors.questionModalWhitePaper.initWhitepaper(
              $input,
              jsonData,
              targetId,
              $clearCanvas,
              $addText,
              $drawingMode,
              $editText,
              $toggleGraphPaper,
              context,
              key
            );

            // Remove tabindex to ensure text boxes are editable
            $input.closest("#overlay-wrap").removeAttr("tabindex");
          });

          // Handle canvas resizing on window resize
          $(window).on("resize", () => {
            Drupal.behaviors.questionModalWhitePaper.whitePapers.forEach((_, index) => {
              Drupal.behaviors.questionModalWhitePaper.adjustCanvasDimensions(index, context);
            });
          });
        }, 100);
      }
    },

    // Adjusts the dimensions of the canvas to be responsive.
    adjustCanvasDimensions(key, context) {
      const container = $(".bg-tier-color .layout-2-col__col__inner .whiteboard-container, .marking-form__answer");
      const canvasObject = Drupal.behaviors.questionModalWhitePaper.whitePapers[key];

      if (!canvasObject || !container.length) return;
      const containerWidth = container.width();
      const zoom = containerWidth / 770;
      const heightRatio = canvasObject.height / canvasObject.width;
      canvasObject.setZoom(zoom);
      canvasObject.setWidth(Math.round(containerWidth));
      canvasObject.setHeight(Math.round(containerWidth * heightRatio));
      canvasObject.width = Math.round(containerWidth);
      canvasObject.height = Math.round(containerWidth * heightRatio);
    },

    // Init white paper, from scratch or reading existing content
    initWhitepaper($this, json, targetId, $clearCanvas, $addText, $drawingMode, $editText, $toggleGraphPaper, context, key) {
      const $container = $('.bg-tier-color .layout-2-col__col__inner .whiteboard-container, .marking-form__answer');
      const $zoom = $container.width() / 770;
      const localHistory = [];
      let isDragging = false;
      const rootStyles = getComputedStyle(document.documentElement);
      const primaryColor = rootStyles.getPropertyValue('--primary').trim();
      const canvas = this.__canvas = new fabric.Canvas('whitepaper-' + targetId, {
        isDrawingMode: true,
      });
      const $backgroundImage = $('[data-whitepaper-image-id="' + targetId + '"]', context);

      canvas.freeDrawingBrush.width = 3;
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = primaryColor;
      fabric.Object.prototype.cornerStyle = 'circle';

      $this.hide();

      if (json !== '') {
        canvas.loadFromJSON(json);
      }

      function appendTextarea(target) {
        if (target && target.isType('textbox')) {
          canvas.setActiveObject(target);
          canvas.isDrawingMode = false;
          target.enterEditing();
          const elementToMove = document.querySelector('[data-fabric-hiddentextarea]');
          const newParentElement = document.querySelector('.modal-body');
          if (elementToMove) newParentElement.appendChild(elementToMove);
          $("[data-fabric-hiddentextarea]").css('z-index', 99999).focus();
        }
      }

      // Update Drupal field when drawing.
      canvas.on('mouse:up', (event) => {
        const originalObject = JSON.parse(JSON.stringify(canvas));
        // Send through the canvas size.
        originalObject.canvasWidth = canvas.width;
        originalObject.canvasHeight = canvas.height;
        $this.val(JSON.stringify(originalObject));

        if (!isDragging) {
          appendTextarea(event.target);
        }
      });

      canvas.on('mouse:dblclick', (event) => {
        appendTextarea(event.target);
      });

      canvas.on('mouse:down', () => isDragging = false);
      canvas.on('mouse:move', () => isDragging = true);

      // Clear canvas on click.
      if ($clearCanvas.length > 0) {
        $clearCanvas.on('click touchstart', function (e) {
          e.preventDefault();

          // Render previous canvas step.
          if (canvas._objects.length > 0) {
            localHistory.push(canvas._objects.pop());
            canvas.discardActiveObject();
            canvas.renderAll();
          }

          // Update Drupal input
          if ($this.length > 0) {
            const newObject = JSON.stringify(canvas);

            if (canvas._objects.length === 0) {
              $this.val('');
            } else {
              $this.val(newObject);
            }
          }
        });
      }

      // Sizes.
      let sizeWidth = 770;
      let sizeHeight = 450;
      let containerWidth = Math.round($container.width());

      const $whitepaper = $('#whitepaper-' + targetId);

      // If background image
      if ($backgroundImage.length > 0) {
        const src = $backgroundImage.attr('src');
        sizeWidth = $backgroundImage.attr('width');
        sizeHeight = $backgroundImage.attr('height');
        $whitepaper.css('background-image', 'url(' + src + ')');
      }
      else {
        $whitepaper.css('background', 'none');
      }
      const newSizeHeight = Math.round(containerWidth * sizeHeight / sizeWidth);
      canvas.setZoom($zoom);
      canvas.setWidth(containerWidth);
      canvas.setHeight(newSizeHeight);
      canvas.width = containerWidth;
      canvas.height = newSizeHeight;


      // Make drawing unselectable when the drawing mode is set to false
      function makeStrokesUnselectable () {
        canvas.forEachObject(function(object) {
          if (!object.text) {
            object.selectable = false;
          }
        });
      }

      if ($addText.length > 0) {
        $addText.on('click touchstart', function (e) {
          e.preventDefault();
          console.log('click on the add text button');
          $editText.addClass('active');
          $drawingMode.removeClass('active');

          let textboxLeft = 400;
          let textboxTop = 300;

          if ($(window).width() > 400) {
            textboxLeft = 300;
            textboxTop = 250;
          }

          const textbox = new fabric.Textbox('Add your text', {
            left: textboxLeft,
            top: textboxTop,
            fontFamily: 'Nexa-Bold',
            fill: '#333',
            fontSize: 18,
            editable : true,
            width: 200,
          });

          canvas.add(textbox);
          canvas.setActiveObject(canvas.item(canvas._objects.length - 1));

          setTimeout(() => {
            const elementToMove = document.querySelector('[data-fabric-hiddentextarea]');
            const newParentElement = document.querySelector('.modal-body');
            if (elementToMove) newParentElement.appendChild(elementToMove);
            $("[data-fabric-hiddentextarea]").css('z-index', 99999).focus();
          }, 100);

          canvas.isDrawingMode = false;
          makeStrokesUnselectable();
        });
      }

      if ($drawingMode.length > 0) {
        $drawingMode.on('click touchstart', function (e) {
          e.preventDefault();
          canvas.isDrawingMode = true;
          $editText.removeClass('active');
          $drawingMode.addClass('active');
          makeStrokesUnselectable();
        });
      }

      if ($editText.length > 0) {
        $editText.on('click touchstart', function (e) {
          e.preventDefault();
          canvas.isDrawingMode = false;
          $editText.addClass('active');
          $drawingMode.removeClass('active');
          makeStrokesUnselectable();
        });
      }

      if ($toggleGraphPaper.length > 0) {
        // The graph paper should only be shown when the whiteboard is expanded.
        $toggleGraphPaper.on('click touchstart', function (e) {
          e.preventDefault();
          const expandedClass = 'whiteboard-expanded';
          const graphPaperBackground = 'repeating-linear-gradient(0deg, transparent, transparent 60px, #aaa 60px, #aaa 61px),repeating-linear-gradient(90deg, transparent, transparent 60px, #aaa 60px, #aaa 61px)';
          if ($whitepaper.css('background') === 'none' || !($container.hasClass(expandedClass))) {
            $whitepaper.css('background', graphPaperBackground);
            $container.addClass(expandedClass);
          } else {
            $whitepaper.css('background', 'none');
            $container.removeClass(expandedClass);
          }

          // I do not know why, but both of these must be present in order for
          // the canvas to get resized properly...
          window.dispatchEvent(new Event('resize'));
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 0);
        });
      }

      Drupal.behaviors.questionModalWhitePaper.whitePapers.push(canvas);


      // Execute canvas resize on review, results, and marking pages where data exists
      const hasRelevantElements = $('.quiz-question-fill-in-the-blank, .quiz-result-answer, .marking-form', context).length > 0;
      const isMarkingFormContext = $(context).is('.marking-form');

      if (hasRelevantElements || isMarkingFormContext) {
        Drupal.behaviors.questionModalWhitePaper.whitePapers.forEach((_, index) => {
          Drupal.behaviors.questionModalWhitePaper.adjustCanvasDimensions(index, context);
        });
      }
    },
  };
})(jQuery, Drupal);